import { Configuration } from 'lib/amwell/sdk/types';
import BaseService from './BaseService';
import { errors } from '../constants';
import AwsdkError from '../errors/AwsdkError';

export default class InitializationService extends BaseService {
  async initialize(configuration: Configuration): Promise<boolean> {
    const key = this.initialize.name;

    try {
      const initialized: boolean = await this.sdk.initialize(configuration);

      if (!initialized) {
        throw errors.INCORRECT_KEY;
      }

      return initialized;
    } catch (err) {
      throw new AwsdkError(key, err);
    }
  }
}
